import { Fragment } from 'react';
import type { OrderStatusResponse } from '../../lib/types';
import { timelineSteps } from './statusModel';

/**
 * 3-step status timeline card (equal columns, 2px connectors — black between
 * done steps, hairline to pending ones; pending steps at 50% opacity).
 */
export function Timeline({ order }: { order: OrderStatusResponse }) {
  const steps = timelineSteps(order);
  return (
    <div className="ost-card ost-timeline">
      <div className="ost-timeline__row">
        {steps.map((step, i) => (
          <Fragment key={step.key}>
            {i > 0 && (
              <span
                className={`ost-timeline__connector${
                  step.state === 'done' ? ' ost-timeline__connector--done' : ''
                }`}
              />
            )}
            <div
              className={`ost-step${step.state === 'pending' ? ' ost-step--pending' : ''}`}
            >
              <span
                className={`ost-step__dot${
                  step.state === 'done' ? ' ost-step__dot--done' : ''
                }`}
              >
                {step.state === 'done' ? '✓' : i + 1}
              </span>
              <span className="ost-step__label">{step.label}</span>
              {step.caption && <span className="ost-step__caption">{step.caption}</span>}
              {step.trackingUrl && (
                <a
                  className="ost-step__track"
                  href={step.trackingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Track your parcel →
                </a>
              )}
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  );
}
